document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.icon-module-wrapper');
  const cards = wrapper?.children;

  if (!cards) return;

  const count = cards.length;

  if (count === 1) {
    wrapper.classList.add('one-card');
  } else if (count === 2) {
    wrapper.classList.add('two-cards');
  } else if (count === 3) {
    wrapper.classList.add('three-cards');
  } else if (count === 4) {
    wrapper.classList.add('four-cards');
  }
});
